/**
 * The tRPC-backed `ConnectionsSource`. Structural typing again: the page never imports the
 * router type, so a change on the server is a type error here and not a silent mismatch.
 */
import type { ConnectionRow, ConnectionsSource, SaveConnectionArgs } from './types';

export interface ConnectionsTrpc {
  connections: {
    list: { query: () => Promise<ConnectionRow[]> };
    save: { mutate: (input: SaveConnectionArgs) => Promise<ConnectionRow> };
    disconnect: { mutate: (input: { app: string }) => Promise<{ app: string; deleted: boolean }> };
  };
}

export function createConnectionsSource(trpc: ConnectionsTrpc): ConnectionsSource {
  return {
    list: () => trpc.connections.list.query(),
    save: (input) => trpc.connections.save.mutate(input),
    disconnect: async (input) => {
      const result = await trpc.connections.disconnect.mutate({ app: input.app });
      return { app: input.app, deleted: result.deleted };
    },
  };
}
